import { create } from "../../../common/utils/zustand_state_manager";
import { IEstoqueService } from "../../../features/controleEstoque/data/services/estoque_service";
import { EstoqueService } from "../../../features/controleEstoque/data/services/estoque_service_impl";

type State = {
  controleEstoqueService: IEstoqueService,
};

export const useControleEstoqueServices = create<State>((set, get) => ({
  controleEstoqueService: new EstoqueService(),
}));